// eslint-disable-next-line jira/restricted/redux
import type { Dispatch, MiddlewareAPI, Middleware } from 'redux';

type Listener<
	TAction extends {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		type: any;
	},
	TState,
> = (action: TAction, state: TState) => void;

export default class ActionListenerMiddleware<
	TAction extends {
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		type: any;
	},
	TState,
> {
	listeners: Listener<TAction, TState>[] = [];

	add: (listener: Listener<TAction, TState>) => void = (listener: Listener<TAction, TState>) => {
		this.listeners.push(listener);
	};

	remove: (listener: Listener<TAction, TState>) => void = (listener: Listener<TAction, TState>) => {
		this.listeners = this.listeners.filter((l) => l !== listener);
	};

	// @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
	perform: Middleware<TState, TAction> =
		(api: MiddlewareAPI<TState>) =>
		(next: Dispatch<TAction>) =>
		(action: TAction): TAction => {
			const result = next(action);
			this.listeners.forEach((listener) => listener(action, api.getState()));
			return result;
		};
}
